import { getToken } from "./auth";
const API_BASE_URL = process.env.REACT_APP_API_BASE_URL || "http://localhost:5000";


function authHeaders() {
  const token = getToken();
  return {
    "Content-Type": "application/json",
    ...(token && { Authorization: `Bearer ${token}` }),
  };
}

export async function apiFetch(path, options = {}) {
  const res = await fetch(`${API_BASE_URL}${path}`, {
    ...options,
    headers: { ...authHeaders(), ...options.headers },
  });
  if (res.status === 401) {
    sessionStorage.removeItem("token");
    sessionStorage.removeItem("user");
    if (window.location.pathname !== "/login") {
      window.location.replace("/login");
    }
    throw new Error("Session expired");
  }

  return res;
}


// Functional Area APIs
export const funcAreaAPI = {
  getAll: async (params = {}) => {
    const qs = new URLSearchParams(params).toString();
    const res = await apiFetch(`/function_area${qs ? `?${qs}` : ''}`);
    return res.json();
  },
  create: async (data) => apiFetch('/function_area', { method: 'POST', body: JSON.stringify(data) }),
  update: async (funcSubAreaCode, data) => apiFetch(`/function_area/${funcSubAreaCode}`, { method: 'PUT', body: JSON.stringify(data) }),
  delete: async (funcSubAreaCode) => apiFetch(`/function_area/${funcSubAreaCode}`, { method: 'DELETE' }),
};

// Training Course APIs
export const trngCourseAPI = {
  getAll: async (params = {}) => {
    const filteredParams = {};
    if (params.func_area_code) filteredParams.func_area_code = params.func_area_code;
    if (params.func_sub_area_code) filteredParams.func_sub_area_code = params.func_sub_area_code;
    if (params.trng_course_name) filteredParams.trng_course_name = params.trng_course_name;
    if (params.trng_course_code) filteredParams.trng_course_code = params.trng_course_code;
    if (params.active_status !== undefined) filteredParams.active_status = params.active_status;
    const qs = new URLSearchParams(filteredParams).toString();
    const res = await apiFetch(`/training_course${qs ? `?${qs}` : ''}`);
    return res.json();
  },
  create: async (data) => apiFetch('/training_course', { method: 'POST', body: JSON.stringify(data) }),
  update: async (funcAreaCode, funcSubAreaCode, trngCourseCode, data) => apiFetch(`/training_course/${funcAreaCode}/${funcSubAreaCode}/${trngCourseCode}`, { method: 'PUT', body: JSON.stringify(data) }),
  delete: async (funcAreaCode, funcSubAreaCode, trngCourseCode) => apiFetch(`/training_course/${funcAreaCode}/${funcSubAreaCode}/${trngCourseCode}`, { method: 'DELETE' }),
};

// Faculty APIs
export const facultyAPI = {
  getAll: async (params = {}) => {
    const qs = new URLSearchParams(params).toString();
    const res = await apiFetch(`/faculty${qs ? `?${qs}` : ''}`);
    return res.json();
  },
  create: async (data) => apiFetch('/faculty', { method: 'POST', body: JSON.stringify(data) }),
  update: async (name, email, data) => apiFetch(`/faculty/${encodeURIComponent(name)}/${encodeURIComponent(email)}`, { method: 'PUT', body: JSON.stringify(data) }),
  delete: async (name, email) => apiFetch(`/faculty/${encodeURIComponent(name)}/${encodeURIComponent(email)}`, { method: 'DELETE' }),
  checkInUse: async (faculty_code) => {
    const res = await apiFetch(`/faculty/in_use?faculty_code=${encodeURIComponent(faculty_code)}`);
    return res.json();
  },
};


// Batch Status APIs
export const batchStatusAPI = {
  getPage: async (params = {}, lastKey = null) => {
    const query = { ...params };
    if (lastKey) query.lastKey = lastKey;
    const qs = new URLSearchParams(query).toString();
    const res = await apiFetch(`/training_batch?${qs}`);
    return res.json();
  },
  create: async (data) => apiFetch('/training_batch', { method: 'POST', body: JSON.stringify(data) }),
  getWithParticipants: async (params = {}) => {
    const qs = new URLSearchParams(params).toString();
    const res = await apiFetch(`/training_batch/with_participants${qs ? `?${qs}` : ''}`);
    return res.json();
  },
  getManDays: async (params = {}) => {
    const qs = new URLSearchParams(params).toString();
    const res = await apiFetch(`/training_batch/man_days${qs ? `?${qs}` : ''}`);
    return res.json();
  },
  update: async (batchSrNo, data) => apiFetch(`/training_batch/${batchSrNo}`, { method: 'PUT', body: JSON.stringify(data) }),
  delete: async (batchSrNo, branch) => apiFetch(`/training_batch/${batchSrNo}${branch ? `?branch=${encodeURIComponent(branch)}` : ''}`, { method: 'DELETE' }),
  checkInUse: async (params = {}) => {
    const qs = new URLSearchParams(params).toString();
    const res = await apiFetch(`/training_batch/in_use${qs ? `?${qs}` : ''}`);
    return res.json();
  },
};

// Course Faculty APIs
export const courseFacultyAPI = {
  getAll: async (params = {}) => {
    const qs = new URLSearchParams(params).toString();
    const res = await apiFetch(`/course_faculty${qs ? `?${qs}` : ''}`);
    return res.json();
  },
  create: async (data) => apiFetch('/course_faculty', { method: 'POST', body: JSON.stringify(data) }),
  update: async (facultycode, funcsubareacode, data) => apiFetch(`/course_faculty/${facultycode}/${funcsubareacode}`, { method: 'PUT', body: JSON.stringify(data) }),
  delete: async (facultycode, funcsubareacode) => apiFetch(`/course_faculty/${facultycode}/${funcsubareacode}`, { method: 'DELETE' }),
};

// User APIs
export const userAPI = {
  getAll: async (params = {}) => {
    const qs = new URLSearchParams(params).toString();
    const res = await apiFetch(`/users${qs ? `?${qs}` : ''}`);
    return res.json();
  },
  create: async (data) => apiFetch('/users', { method: 'POST', body: JSON.stringify(data) }),
  update: async (salcode, roletype, data) => apiFetch(`/users/${salcode}/${roletype}`, { method: 'PUT', body: JSON.stringify(data) }),
  delete: async (salcode, roletype) => apiFetch(`/users/${salcode}/${roletype}`, { method: 'DELETE' }),
};

// Batch Details APIs
export const batchDetailsAPI = {
  getParticipants: async (batchSrNo) => {
    const res = await apiFetch(`/training_needs/by_batch?batch_sr_no=${encodeURIComponent(batchSrNo)}`);
    return res.json();
  },
  getBatch: async (batchSrNo) => {
    const json = await batchStatusAPI.getPage({ batch_sr_no: batchSrNo, limit: 1 }, null);
    return Array.isArray(json.items) ? json.items[0] ?? null : null;
  },
};

// Training Needs APIs
export const trainingNeedsAPI = {
  getSummary: async (params = {}) => {
    const qs = new URLSearchParams(params).toString();
    const res = await apiFetch(`/training_needs/summary${qs ? `?${qs}` : ''}`);
    return res.json();
  },
  getDetails: async (params = {}) => {
    const qs = new URLSearchParams(params).toString();
    const res = await apiFetch(`/training_needs/details${qs ? `?${qs}` : ''}`);
    return res.json();
  },
  getTrainingNeeds: async (params = {}) => {
    const qs = new URLSearchParams(params).toString();
    const res = await apiFetch(`/training_needs${qs ? `?${qs}` : ''}`);
    return res.json();
  },
  update: async (salcode, trngcoursecode, dateofentry, data) =>
    apiFetch(`/training_needs/${salcode}/${trngcoursecode}/${dateofentry}`, {
      method: 'PUT',
      body: JSON.stringify(data),
  }),
  create: async (data) => apiFetch('/training_needs', { method: 'POST', body: JSON.stringify(data) }),
  deleteTrainingNeed: async (salcode, trngcoursecode, dateofentry) => apiFetch(`/training_needs/${salcode}/${trngcoursecode}/${dateofentry}`, { method: 'DELETE' }),
};

// Employee Training Completion API
export const empTrainingCompletionAPI = {
  getSummary: async (params = {}) => {
    const qs = new URLSearchParams(params).toString();
    const res = await apiFetch(`/training_needs/day_wise_completion${qs ? `?${qs}` : ''}`);
    return res.json();
  },
  getDetails: async (params = {}) => {
    const qs = new URLSearchParams(params).toString();
    const res = await apiFetch(`/training_needs/details${qs ? `?${qs}` : ''}`);
    return res.json();
  },
};

// Training Matrix API
export const trainingMatrixAPI = {
  getEmpFuncSubArea: async (params = {}) => {
    const qs = new URLSearchParams(params).toString();
    const res = await apiFetch(`/training_needs/emp_func_sub_area${qs ? `?${qs}` : ''}`);
    return res.json();
  },
};

// Employee Training Identified API
export const empTrainingIdentifiedAPI = {
  getAll: async (params = {}) => {
    const qs = new URLSearchParams(params).toString();
    const res = await apiFetch(`/training_needs/empidentified${qs ? `?${qs}` : ''}`);
    return res.json();
  },
  getDetail: async (sal_code) => {
    const res = await apiFetch(`/training_needs/empidentified_detail?sal_code=${encodeURIComponent(sal_code)}`);
    return res.json();
  },
};

// Employee API
export const employeeAPI = {
  getDistinctFilters: async () => {
    const res = await apiFetch('/distinct-filters');
    return res.json();
  },
  getByFilters: async (params = {}) => {
    const qs = new URLSearchParams(params).toString();
    const res = await apiFetch(`/distinct-filters/employees${qs ? `?${qs}` : ''}`);
    return res.json();
  },
  getBySalCodes: async (salCodes = []) => {
    if (!salCodes.length) return [];
    const res = await apiFetch(`/distinct-filters/employees?sal_codes=${salCodes.join(',')}`);
    return res.json();
  },
};

// SMS API
export const smsAPI = {
  sendAnnouncement: async (messages) => {
    const res = await apiFetch('/sms/announce', {
      method: 'POST',
      body: JSON.stringify({ messages }),
    });
    return res.json();
  },
};

// Email API
export const emailAPI = {
  send: async (data) => apiFetch('/email/send', { method: 'POST', body: JSON.stringify(data) }),
  notifyEmployee: async (data) => apiFetch('/email/notify/employee', { method: 'POST', body: JSON.stringify(data) }),
  notifySuperior: async (data) => apiFetch('/email/notify/superior', { method: 'POST', body: JSON.stringify(data) }),
  notifyFaculty: async (data) => apiFetch('/email/notify/faculty', { method: 'POST', body: JSON.stringify(data) }),
  notifyManager: async (data) => apiFetch('/email/notify/manager', { method: 'POST', body: JSON.stringify(data) }),
  attendanceAccounts: async (data) => apiFetch('/email/attendance/accounts', { method: 'POST', body: JSON.stringify(data) }),
  attendanceDPH: async (data) => apiFetch('/email/attendance/dph', { method: 'POST', body: JSON.stringify(data) }),
  cancellationEmployee: async (data) => apiFetch('/email/cancellation/employee', { method: 'POST', body: JSON.stringify(data) }),
  cancellationSuperior: async (data) => apiFetch('/email/cancellation/superior', { method: 'POST', body: JSON.stringify(data) }),
  nominationConfirm: async (data) => apiFetch('/email/nomination/confirm', { method: 'POST', body: JSON.stringify(data) }),
  nominationCancel: async (data) => apiFetch('/email/nomination/cancel', { method: 'POST', body: JSON.stringify(data) }),
  nominConfirmEmployee: async (data) => apiFetch('/email/nominconfirm/employee', { method: 'POST', body: JSON.stringify(data) }),
  nominConfirmDPH: async (data) => apiFetch('/email/nominconfirm/dph', { method: 'POST', body: JSON.stringify(data) }),
  batchCompletionReminder: async (data) => apiFetch('/email/batch/completion-reminder', { method: 'POST', body: JSON.stringify(data) }),
};
